import { useEffect } from "react";
import { animate, motion, useMotionValue, useTransform } from "framer-motion";
import { WAITLIST_MIN } from "@/lib/site";

const CountUp = ({ value }) => {
  const mv = useMotionValue(0);
  const text = useTransform(mv, (v) => Math.round(v).toLocaleString("it-IT"));
  useEffect(() => {
    const controls = animate(mv, value, { duration: 1.4, ease: [0.16, 1, 0.3, 1] });
    return () => controls.stop();
  }, [mv, value]);
  return <motion.span data-testid="waitlist-count" className="tabular-nums text-acid">{text}</motion.span>;
};

export const WaitlistCounter = ({ count }) => {
  if (count === null) return null;
  return (
    <p data-testid="waitlist-counter" className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-bone">
      <span className="relative flex h-2 w-2">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-acid opacity-60" />
        <span className="relative inline-flex h-2 w-2 rounded-full bg-acid" />
      </span>
      {count >= WAITLIST_MIN ? (
        <span><CountUp value={count} /> fan già in lista</span>
      ) : (
        <span>Entra tra i primi fan di InkMaster</span>
      )}
    </p>
  );
};
